module.exports = __webpack_public_path__ + "img/avatar.21eb033f.jpg";